import React, { useState, useEffect, useMemo } from "react";
import { useParams, useLocation, useSearchParams } from "react-router-dom";
import cn from "classnames";
import { heading, tableData } from "../../../services/serviceRequestsTableData";
import Image from "../../../assets/images/model_Image.svg";
import Button from "../../Buttons/button";
import { motion, AnimatePresence } from "framer-motion";
import ServiceRequestTableBody from "../../Table/tableBodies/serviceRequestTableBody";
import ModelsSidebar from "../../models-Sidebar/models-sidebar";
import { useSelector, useDispatch } from "react-redux";
import Unicon from "../../../assets/images/arrow-down-circle.svg";
import serviceRequest from "../../../assets/images/serviceRequest.png";
import {
  selectCompanyDashboard,
  updatedEmployeeRequests,
} from "../../../redux/slices/companyDashboardSlice";
const initialState = {
  request_date: false,
  status: false,
  request_type: false,
  reason: false,
  comment: false,
  upDown: false,
};

function ServiceRequestsTableModel({ setstate, setPopup, dashboard }) {
  const [show, setShow] = useState(false);
  const [Services, setServices] = useState("");
  const [btns, setBtns] = useState(initialState);
  const [active, setActive] = useState("");
  const dispatch = useDispatch();
  const [orderType, setOrderType] = useState("asc");
  const State = useSelector(selectCompanyDashboard);
  const { usageReportRequestData } = State;
  const [servicereqid, setservicereqid] = useState();
  const [currentSelectedType, setCurrentSelectedType] = useState("");

  const location = useLocation();
  const [queryParameters] = useSearchParams()
  const [requestModal, setRequestModel] = useState(null);
  const requestId = queryParameters.get("request_id")
  const transformedData = useMemo(() => transformResponse(usageReportRequestData?.requests), [usageReportRequestData])

  useEffect(()=>{
    if (requestId && requestModal === null){
      setRequestModel(true)
    }
  }, [queryParameters, requestModal]);

  useEffect(() => {
    if (requestModal && requestId && transformedData.length > 0) {
      const matchedRow = transformedData.find(
        (item) => item.reason?.id === Number(requestId)
      );
      setservicereqid({
        id: matchedRow?.reason?.id,
        userId: matchedRow?.reason?.user_id,
        service_id: matchedRow?.reason?.service_id,
      });
    }
  }, [requestModal, transformedData]);

  useEffect(() => {
    if (servicereqid && Object.keys(servicereqid).length > 0) {
      setShow(true);
    }
  }, [servicereqid]);

  const handleStatus = (type, set) => {
    setBtns({
      ...btns,
      status: true,
      upDown: set ? !btns.upDown : false,
      [active !== "status" && active]: false,
    });
    setActive("status");
    const sortedData = [...usageReportRequestData?.requests].sort((a, b) => {
      if (type === "asc") {
        return a.status.localeCompare(b.status);
      } else {
        return b.status.localeCompare(a.status);
      }
    });
    dispatch(updatedEmployeeRequests(sortedData));
    setOrderType(orderType === "asc" ? "desc" : "asc");
  };

  const handleRequestType = (type, set) => {
    setBtns({
      ...btns,
      request_type: true,
      upDown: set ? !btns.upDown : false,
      [active !== "request_type" && active]: false,
    });
    setActive("request_type");
    const sortedData = [...usageReportRequestData?.requests].sort((a, b) => {
      if (type === "asc") {
        return a.request_type.localeCompare(b.request_type);
      } else {
        return b.request_type.localeCompare(a.request_type);
      }
    });
    dispatch(updatedEmployeeRequests(sortedData));
    setOrderType(orderType === "asc" ? "desc" : "asc");
  };

  const handleReason = (type, set) => {
    setBtns({
      ...btns,
      reason_type: true,
      upDown: set ? !btns.upDown : false,
      [active !== "reason_type" && active]: false,
    });
    setActive("reason_type");
    const sortedData = [...usageReportRequestData?.requests].sort((a, b) => {
      if (type === "asc") {
        return a.reason_type.localeCompare(b.reason_type);
      } else {
        return b.reason_type.localeCompare(a.reason_type);
      }
    });
    dispatch(updatedEmployeeRequests(sortedData));
    setOrderType(orderType === "asc" ? "desc" : "asc");
  };

  const handleComment = (type, set) => {
    setBtns({
      ...btns,
      comment: true,
      upDown: set ? !btns.upDown : false,
      [active !== "comment" && active]: false,
    });
    setActive("comment");
    const sortedData = [...usageReportRequestData?.requests].sort((a, b) => {
      if (type === "asc") {
        return Number(a.comments_count) - Number(b.comments_count);
      } else {
        return Number(b.comments_count) - Number(a.comments_count);
      }
    });
    dispatch(updatedEmployeeRequests(sortedData));
    setOrderType(orderType === "asc" ? "desc" : "asc");
  };

  const handleRequestby = (type, set) => {
    setBtns({
      ...btns,
      user_name: true,
      upDown: set ? !btns.upDown : false,
      [active !== "user_name" && active]: false,
    });
    setActive("user_name");
    const sortedData = [...usageReportRequestData?.requests].sort((a, b) => {
      if (type === "asc") {
        return a.user_name.localeCompare(b.user_name);
      } else {
        return b.user_name.localeCompare(a.user_name);
      }
    });
    dispatch(updatedEmployeeRequests(sortedData));
    setOrderType(orderType === "asc" ? "desc" : "asc");
  };

  const parseDate = (dateString) => {
    const [day, month, year] = dateString.split("/");
    return new Date(`${year}-${month}-${day}`);
  };

  const handleRequestDate = (orderType) => {
    setBtns({
      ...btns,
      request_date: true,
      // upDown: set ? !btns.upDown : false,
      // [active !== "requested_on" && active]: false,
    });
    setActive("request_date");
    const sort = [...usageReportRequestData?.requests].sort((a, b) => {
      const dateA = parseDate(a.request_date);
      const dateB = parseDate(b.request_date);

      if (orderType === "asc") {
        return dateB - dateA;
      } else {
        return dateA - dateB;
      }
    });
    dispatch(updatedEmployeeRequests(sort));
    setOrderType(orderType == "asc" ? "desc" : "asc");
  };

  // const handleUpdown = () => {

  //   let type = "asc";

  //   if (!btns.upDown) {
  //     type = "dec";
  //   }

  //   btns.request_date && handleRequestDate(type, true);
  //   btns.status && handleStatus(type, true);
  //   btns.request_type && handleRequestType(type, true);
  //   btns.reason && handleReason(type, true);
  //   btns.comment && handleComment(type, true);
  // };
  const handlerRequest = {
    Status: handleStatus,
    "Request Type": handleRequestType,
    Reason: handleReason,
    Comments: handleComment,
    "Requested by": handleRequestby,
    "Request date": handleRequestDate,
  };

  function transformResponse(response = []) {
    return response?.map((item) => {
      return {
        requestType: item.request_type,
        status: item.status,
        reason: {
          id: item.id,
          service_id: item.service_id,
          user_id: item.user_id,
          heading: item.reason_type,
          subHeading: `${item.reason_details}`,
        },
        comments: item.comments_count == 0 ? "-" : item.comments_count,
        requestedBy: {
          image: item.image_url,
          name: item.user_name,
          work: item.distinction,
        },
        requestDate: item.request_date,
      };
    });
  }

  const closeSidebar = () => {
    if (show === true) {
      setShow(false);
    }
  };

  return (
    <div className="service-request-parent-modal relative px-[20px] min-w-[100vw] w-auto 2xl:min-w-full 2xl:w-[1300px]">
      <div
        style={{
          height: "calc(100vh - 80px)",
        }}
        className="relative w-full pt-[81px] overflow-y-hidden bg-[#363D50] rounded-[16px] flex flex-row"
      >
        <div className="w-full">
          <div className="flex w-full absolute bg-[#363D50] z-[2] rounded-t-[16px] top-0 left-0 justify-between px-[24px] py-[16px] border-b-[1px] border-[#41485C]">
            <div className="flex flex-start items-center gap-[16px]">
              <img
                className="w-[56px] h-[56px] card_img rounded-lg"
                src={usageReportRequestData.service_image_url}
                alt="service-img"
              />
              <div className="flex flex-col">
                <span className="text-primary !text-left !text-[24px]">
                  Service requests
                </span>
                <span className="text-secondary !text-left">
                  {usageReportRequestData.total_count} total
                </span>
              </div>
            </div>
            <div className="flex h-[40px] justify-end items-center">
              <svg
                className="cursor-pointer"
                onClick={() => {
                  setPopup(false);
                }}
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.4099 12.0002L17.7099 7.71019C17.8982 7.52188 18.004 7.26649 18.004 7.00019C18.004 6.73388 17.8982 6.47849 17.7099 6.29019C17.5216 6.10188 17.2662 5.99609 16.9999 5.99609C16.7336 5.99609 16.4782 6.10188 16.2899 6.29019L11.9999 10.5902L7.70994 6.29019C7.52164 6.10188 7.26624 5.99609 6.99994 5.99609C6.73364 5.99609 6.47824 6.10188 6.28994 6.29019C6.10164 6.47849 5.99585 6.73388 5.99585 7.00019C5.99585 7.26649 6.10164 7.52188 6.28994 7.71019L10.5899 12.0002L6.28994 16.2902C6.19621 16.3831 6.12182 16.4937 6.07105 16.6156C6.02028 16.7375 5.99414 16.8682 5.99414 17.0002C5.99414 17.1322 6.02028 17.2629 6.07105 17.3848C6.12182 17.5066 6.19621 17.6172 6.28994 17.7102C6.3829 17.8039 6.4935 17.8783 6.61536 17.9291C6.73722 17.9798 6.86793 18.006 6.99994 18.006C7.13195 18.006 7.26266 17.9798 7.38452 17.9291C7.50638 17.8783 7.61698 17.8039 7.70994 17.7102L11.9999 13.4102L16.2899 17.7102C16.3829 17.8039 16.4935 17.8783 16.6154 17.9291C16.7372 17.9798 16.8679 18.006 16.9999 18.006C17.132 18.006 17.2627 17.9798 17.3845 17.9291C17.5064 17.8783 17.617 17.8039 17.7099 17.7102C17.8037 17.6172 17.8781 17.5066 17.9288 17.3848C17.9796 17.2629 18.0057 17.1322 18.0057 17.0002C18.0057 16.8682 17.9796 16.7375 17.9288 16.6156C17.8781 16.4937 17.8037 16.3831 17.7099 16.2902L13.4099 12.0002Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>

          {/*<div className="flex gap-[12px] px-[24px] py-[8px] border-b-[1px] border-[#41485C] overflow-scroll scrollbar-hide items-center">
            <Button
              onClick={() => {
                handleRequestDate("asc", false);
              }}
              hoverOutlined={!btns.request_date}
              outlined={btns.request_date}
              secondaryHoverOutlined={true}
            >
              Request date
            </Button>
            <Button
              onClick={() => {
                handleStatus("asc", false);
              }}
              hoverOutlined={!btns.status}
              outlined={btns.status}
              secondaryHoverOutlined={true}
            >
              Status
            </Button>
            <Button
              onClick={() => {
                handleRequestType("asc", false);
              }}
              hoverOutlined={!btns.request_type}
              outlined={btns.request_type}
              secondaryHoverOutlined={true}
            >
              Request type
            </Button>
            <Button
              onClick={() => {
                handleReason("asc", false);
              }}
              hoverOutlined={!btns.reason}
              outlined={btns.reason}
              secondaryHoverOutlined={true}
            >
              Reason
            </Button>


            <Button
              onClick={() => {
                handleComment("asc", false);
              }}
              hoverOutlined={!btns.comment}
              outlined={btns.comment}
              secondaryHoverOutlined={true}
            >
              Comment
            </Button>

            <Button
              onClick={handleUpdown}
              hoverOutlined={!btns.upDown}
              outlined={btns.upDown}
              secondaryHoverOutlined={true}
            >
              <div className="pt-[4px] pl-[6px] pb-[4px] pr-[6px]">
                <svg
                  width="16"
                  height="14"
                  viewBox="0 0 16 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.23466 0.207432L4.27333 0.202671L4.33333 0.199951L4.38333 0.201991L4.46734 0.213552L4.54134 0.233953L4.61534 0.263874L4.68067 0.299236L4.75001 0.349558L4.80468 0.399201L8.47142 4.13939C8.59099 4.26177 8.66041 4.42598 8.66558 4.59867C8.67075 4.77137 8.61128 4.93959 8.49926 5.06918C8.38723 5.19877 8.23105 5.28001 8.06243 5.2964C7.89381 5.31278 7.7254 5.26308 7.5914 5.1574L7.52873 5.10096L5.00001 2.52227V13.1206C4.99983 13.2939 4.93476 13.4606 4.81811 13.5867C4.70146 13.7127 4.54203 13.7885 4.3724 13.7987C4.20277 13.8089 4.03574 13.7526 3.90544 13.6413C3.77513 13.5301 3.69139 13.3723 3.67132 13.2002L3.66665 13.1206V2.52227L1.13793 5.10096C1.02313 5.21804 0.870397 5.28838 0.708377 5.29877C0.546356 5.30916 0.386185 5.25889 0.257913 5.1574L0.195245 5.10096C0.0804581 4.98386 0.0115025 4.82806 0.00131483 4.6628C-0.00887284 4.49753 0.0404075 4.33415 0.13991 4.20331L0.195245 4.13939L3.86199 0.399201C3.88526 0.375378 3.91022 0.353331 3.93666 0.333238L4.00999 0.284955L4.08599 0.248234L4.156 0.224432L4.23466 0.207432ZM11.6668 0.199951C11.8301 0.199973 11.9877 0.261124 12.1097 0.371806C12.2318 0.482488 12.3097 0.635002 12.3288 0.800421L12.3335 0.879985V11.4783L14.8622 8.89962L14.9249 8.84318C15.0532 8.74176 15.2133 8.69155 15.3753 8.70198C15.5373 8.7124 15.69 8.78274 15.8047 8.8998C15.9195 9.01687 15.9885 9.17262 15.9987 9.33784C16.0089 9.50307 15.9597 9.66642 15.8602 9.79727L15.8049 9.86119L12.1382 13.6014L12.1088 13.6293L12.0635 13.6673L11.9902 13.7156L11.9142 13.7523L11.8442 13.7761L11.7662 13.7931L11.7062 13.7999H11.6275L11.5875 13.7959L11.5115 13.7823L11.4388 13.7598L11.3848 13.7367L11.3195 13.7013L11.2555 13.6558C11.2344 13.6389 11.2144 13.6207 11.1955 13.6014L7.52873 9.86119L7.4734 9.79727C7.38269 9.67801 7.33345 9.53135 7.33345 9.38041C7.33345 9.22946 7.38269 9.08281 7.4734 8.96355L7.52873 8.89962L7.5914 8.84318C7.70832 8.75065 7.8521 8.70043 8.00008 8.70043C8.14806 8.70043 8.29183 8.75065 8.40875 8.84318L8.47142 8.89962L11.0001 11.4783V0.879985L11.0048 0.800421C11.0239 0.635002 11.1019 0.482488 11.2239 0.371806C11.3459 0.261124 11.5035 0.199973 11.6668 0.199951Z"
                    fill="white"
                  />
                </svg>
              </div>
            </Button>
          </div>*/}
          {usageReportRequestData &&
          usageReportRequestData.total_count === 0 ? (
            <div className="card-section">
              <div className="cards_wrap inner_space flex flex-col gap-[40px] h-[100vh] lg:h-[calc(100vh-135px)] overflow-y-scroll scrollbar-hide home_module">
                <div className="imgWrapper">
                  <img src={serviceRequest} alt="img" className="boxImg" />
                  <div className="boxHeading">No service requests</div>
                  <div className="boxText">
                    When users request a change to this service, it'll show up
                    here.
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="px-[10px] overflow-y-scroll scrollbar-hide h-full">
              <table className="table-auto w-[100%] ">
                <thead className="table-head">
                  <tr>
                    {heading.map((item, index) => (
                      <th
                        key={index}
                        className="py-[10px] text-left text-secondary"
                        onClick={() => setCurrentSelectedType(item)}
                      >
                        <Button
                          onClick={() => handlerRequest[item](orderType, false)}
                          className="sorting_btn_wrapper"
                          secondaryHoverOutlined={true}
                          outlined={true}
                        >
                          <span className="flex items-center">
                            {item}
                            <img
                              className={cn("ml-2 sortingicon", {
                                "rotate-180":
                                  currentSelectedType === item &&
                                  orderType === "desc",
                              })}
                              src={Unicon}
                              alt="icon"
                            />
                          </span>
                        </Button>
                      </th>
                    ))}
                  </tr>
                </thead>
                <ServiceRequestTableBody
                  show={show}
                  setShow={setShow}
                  model={true}
                  tableData={transformedData}
                  setservicereqid={setservicereqid}
                />
              </table>
            </div>
          )}
        </div>
        <AnimatePresence>
          {show === true && (
            <motion.div
              className="w-full h-full absolute z-50 backdrop-blur-sm sideModal_nav"
              initial={{ opacity: 0, x: 500 }}
              transition={{ duration: 0.3 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 500 }}
              onClick={closeSidebar}
            >
              <ModelsSidebar
                model={"request"}
                show={show}
                setShow={setShow}
                id={servicereqid && servicereqid}
                dashboard={dashboard}
              />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}

export default ServiceRequestsTableModel;
